import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About LED Scroller</h3>
          <p>
            LED Scroller is a versatile digital signage solution that helps you create
            stunning LED displays for your business, events, or personal use.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FacebookIcon />
            </a>
            <a href="https://x.com/aicreativestack" target="_blank" rel="noopener noreferrer" aria-label="X">
              <TwitterIcon />
            </a>
            <a href="https://www.instagram.com/ledscroller_site/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <InstagramIcon />
            </a>
            <a href="https://www.youtube.com/channel/UC6DcfruqKIWu7zAH5GzIQmQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <YouTubeIcon />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/template">Templates</Link></li>
            <li><Link to="/application">Application</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/?recover=1">Recover download</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <div className="contact-info">
            <p>
              <LocationOnIcon /> 123 opp. J H Ambani School, Piplod, Surat, Gujarat 395007
            </p>
            <p>
              <EmailIcon /> <a href="mailto:usercontactcare@gmail.com">usercontactcare@gmail.com</a>
            </p>
            <p>
              <PhoneIcon /> <a href="tel:+15551234567">+1 (555) 123-****</a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} LED Scroller. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 